const LENDER_BOARD_REDUCER_PATH = "lenderBoardApi";
const LENDER_BOARD_SERVICE_TAG = "LenderBoard";

const LENDER_BOARD_RELATED_TAGS = [LENDER_BOARD_SERVICE_TAG];

export { LENDER_BOARD_REDUCER_PATH, LENDER_BOARD_SERVICE_TAG, LENDER_BOARD_RELATED_TAGS };

